import createReducer from 'reducers/createReducer';

import { ShopClientInfo } from 'actions/actionTypes';

const INITIAL_STATE = {
    data: {
        password: '',
        editStatus: null,
    },
    error: {
        triggered: false,
        message: '',
    },
    loading: false, // 로딩 상태를 관리
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
    [ShopClientInfo.EDIT_SHOP_CLIENT_PW_REQUEST]: (state, action) => ({
        ...state,
        error: INITIAL_STATE.error, // 에러 리셋
        loading: true,  // 로딩 상태 활성화
        editStatus: null,  // 이전 요청 상태 리셋
    }),

    // 성공 액션 처리
    [ShopClientInfo.EDIT_SHOP_CLIENT_PW_REQUEST_SUCCESS]: (state, action) => {
        state.data = {
            ...state.data,  // 기존 데이터 유지
            editStatus: 'success'  // 상태 업데이트
        };
    },

    [ShopClientInfo.EDIT_SHOP_CLIENT_PW_REQUEST_FAILURE]: (state, action) => {
        state.data = {
            ...state.data,  // 기존 데이터 유지
            editStatus: 'failure',  // 실패 상태 업데이트
        };

        state.error = {
            triggered: true,
            message: action.payload || 'Failed request',  // 에러 메시지 업데이트
        };
    },
});

export default reducer;
